import { ref, watch } from 'vue';
import { defineStore } from 'pinia';

export const useDirectionStore = defineStore('direction', () => {
  // // Direction flags (Booleans, Nulls, & Undefineds)
  // // Direction figures (Numbers)
  // // Direction text (Strings)
  const directionGroup = ref(localStorage.getItem('directionGroup'));
  const directionModule = ref(localStorage.getItem('directionModule'));
  // // Direction lists (Arrays)
  // // Direction dictionaries (Objects)

  // // Actions

  const blankDirection = () => {
    // console.log(' BLANK DIRECTION');

    directionGroup.value = '';
    directionModule.value = '';
  };

  // // Getters

  //

  // // Watchers

  watch(directionGroup, () => {
    localStorage.setItem('directionGroup', directionGroup.value);
  });

  watch(directionModule, () => {
    localStorage.setItem('directionModule', directionModule.value);
  });

  return {
    directionGroup,
    directionModule,
    blankDirection,
  };
});
